import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiChannelResponse } from './channels-response.models';

import { USER_SERVICE_CONFIG, UserServiceConfigInterface } from '../../config/user-service.config.interface';
import { Channel, ChannelType } from '../../state/channels/channels.models';

@Injectable()
export class ChannelsService {
  private channelsApiUrl: string;

  constructor(
    @Inject(USER_SERVICE_CONFIG) userServiceConfig: UserServiceConfigInterface,
    private httpClient: HttpClient
  ) {
    this.channelsApiUrl = userServiceConfig.channelsApiUrl;
  }

  getNewsfeedChannels(): Observable<Channel[]> {
    return this.httpClient
      .get<{ channels: ApiChannelResponse[] }>(`${this.channelsApiUrl}/channels`)
      .pipe(map((response) => response.channels.map(this.transformApiChannel)));
  }

  subscribeChannel(fairId: string, channelType: ChannelType, id: string): Observable<Channel> {
    return this.httpClient
      .put<ApiChannelResponse>(`${this.channelsApiUrl}/channels/${fairId}/${channelType}/${id}`, null)
      .pipe(map((apiChannel) => this.transformApiChannel(apiChannel)));
  }

  unsubscribeChannel(fairId: string, channelType: ChannelType, id: string): Observable<Channel> {
    return this.httpClient
      .delete<ApiChannelResponse>(`${this.channelsApiUrl}/channels/${fairId}/${channelType}/${id}`)
      .pipe(map((apiChannel) => this.transformApiChannel(apiChannel)));
  }

  markChannelAsVisited(fairId: string, channelType: ChannelType, id: string): Observable<Channel> {
    return this.httpClient
      .get<ApiChannelResponse>(`${this.channelsApiUrl}/channels/${fairId}/${channelType}/${id}/touch`)
      .pipe(map((apiChannel) => this.transformApiChannel(apiChannel)));
  }

  private transformApiChannel(channel: ApiChannelResponse): Channel {
    return {
      id: channel.entity_id,
      type: channel.entity_type,
      name: channel.entity_name,
      fairId: channel.fair_id,
      state: channel.state,
      lastVisitedAt: new Date(channel.last_visited_at),
      news: channel.news_since_last_visit,
    };
  }
}
